import { useState, useEffect } from 'react';
import MessageModal from './MessageModal';

function MessageManager() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [recipientId, setRecipientId] = useState(null);
    const [recipientName, setRecipientName] = useState('');
    const [onMessageSent, setOnMessageSent] = useState(null);

    useEffect(() => {
        const handleOpenModal = (event) => {
            const { recipientId, recipientName, onMessageSent } = event.detail;
            setRecipientId(recipientId);
            setRecipientName(recipientName);
            setOnMessageSent(() => onMessageSent);
            setIsModalOpen(true);
        };

        window.addEventListener('openMessageModal', handleOpenModal);

        return () => {
            window.removeEventListener('openMessageModal', handleOpenModal);
        };
    }, []);

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setRecipientId(null);
        setRecipientName('');
        setOnMessageSent(null);
    };

    const handleMessageSent = () => {
        if (onMessageSent) {
            onMessageSent();
        }
    };

    return (
        <MessageModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            recipientId={recipientId}
            recipientName={recipientName}
            onMessageSent={handleMessageSent}
        />
    );
}

export default MessageManager;
